export default (form) => {
  $('select.autocomplete', form).each((index, select) => {
    const $select = $(select);
    const options = Array.from($('option', $select)).reduce((collection, option) => {
      collection.push(option.text);
      return collection;
    }, []);
    const $input = $(`<input class="form__control" type="text" name="${$select.attr('name')}" placeholder="${$select.attr('placeholder')}">`).insertAfter($select);

    $input.autocomplete({
      source: [options],
      minLength: 2,
      visibleLimit: 4,
      autoselect: true
    }).on('selected.xdsoft', () => {
      $input.blur();
    });

    $select.remove();
    return $input;
  });
};
